/**
 * Typesense search field weights for stock footage
 * Used in hybrid search queries to balance semantic and keyword matching
 */
export const STOCK_FOOTAGE_SEARCH_WEIGHTS = {
  EMBEDDING: 10,
  KEYWORDS: 10,
  TITLE: 5,
  DESCRIPTION: 3,
} as const;

/**
 * Target ratio of free assets in merged stock footage search results.
 * Premium ratio is the complement (1 - FREE_ASSET_RATIO).
 */
export const FREE_ASSET_RATIO = 0.6;
